import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendMutationDeleteProjectSectionArgs,
  BackendProjectSection,
} from 'src/types/backend';

const MUTATION = gql`
  mutation DeleteProjectSection($id: ID!) {
    deleteProjectSection(id: $id) {
      id
    }
  }
`;

export const deleteProjectSection = async (
  variables: BackendMutationDeleteProjectSectionArgs
): Promise<Pick<BackendProjectSection, 'id'> | undefined> => {
  const response = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Pick<BackendProjectSection, 'id'>>(response.data);
};
